import { Controller } from "@hotwired/stimulus"
import { focusSearchForShortcut } from "../lib/activity_feed_search.mjs"

// Replaces the browser's page-only find shortcut while the claim activity feed is visible.
export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
  }

  handleKeydown(event) {
    focusSearchForShortcut(event, this.inputTarget)
  }
}
